import moment from "moment-timezone";
import { useMemo } from "react";

type Interview = {
  id: string;
  startTime: GraphQL_DateTime;
  endTime: GraphQL_DateTime;
};

export function useFormattedDateTimesForInterviewItem({
  interview,
  hideStartTimeNotification,
  timezone,
}: {
  interview: Interview;
  hideStartTimeNotification?: boolean;
  timezone?: string | null;
}) {
  const formattedDateTime = useMemo(() => {
    const startTimeWithTimezone = moment(interview.startTime).tz(
      timezone ?? moment.tz.guess()
    );
    const endTimeWithTimezone = moment(interview.endTime).tz(
      timezone ?? moment.tz.guess()
    );
    const formattedDate = startTimeWithTimezone.format("ddd, MMM D");
    const day = startTimeWithTimezone.format("D");
    const dayName = startTimeWithTimezone.format("ddd");
    const formattedTimeRange = `${startTimeWithTimezone.format(
      "h:mma"
    )} - ${endTimeWithTimezone.format("h:mma z")}`;
    let startsIn = null;
    const isInPast = endTimeWithTimezone.diff(new Date()) < 0;
    if (!hideStartTimeNotification) {
      const differenceInMinutes = startTimeWithTimezone.diff(
        new Date(),
        "minutes"
      );

      if (differenceInMinutes > 0 && differenceInMinutes < 60) {
        startsIn = differenceInMinutes;
      }
    }

    return {
      formattedStartDate: formattedDate,
      formattedTime: formattedTimeRange,
      day,
      dayName,
      startsIn,
      isInPast,
      rawStartTime: startTimeWithTimezone,
      rawEndTime: endTimeWithTimezone,
    };
  }, [
    interview.startTime,
    interview.endTime,
    timezone,
    hideStartTimeNotification,
  ]);

  return formattedDateTime;
}
